
export function getDeferredPromise<T>(): [Promise<T>, (value?: T | PromiseLike<T>) => void, (reason?: any) => void] {
    let deferredResolve: (value?: T | PromiseLike<T>) => void;
    let deferredReject: (reason?: any) => void;
    const promise = new Promise<T>((resolve, reject) => {
        deferredResolve = resolve;
        deferredReject = reject;
    });

    return [promise, deferredResolve, deferredReject];
}
